import React, { useEffect, useState } from 'react'; 
import './LocationPageCss/Locationvideo.css';

function Locationvideo(props) {
  // 1) Open by default
  const [isOpen, setIsOpen] = useState(true);
  const [dta, setData] = useState([]);

  const closeVideo = () => {
    setIsOpen(false);
  };

  const firstId = props.data.length > 0 ? props.data[0].id : null;
  useEffect(() => {
    fetch(`https://backend.corporateeventplanner.in/api/cyj-location-other-data/${firstId}`)
      .then((response) => response.json())
      .then((result) => setData(result))
      .catch((error) => console.log(error));
  }, [firstId]);

  const videoframe = () => {
    const urls = dta.flatMap(i =>
      i.RecentClip.map(a => a.RecentClipUrl)
    );
    return urls.length > 0
      ? urls[0]
      : "https://www.youtube.com/embed/ACn98KGlouM";
  };

  // Extract the video ID from the URL for the loop=playlist parameter
  const getVideoId = (url) => {
    const match = url.match(/\/embed\/([^?]+)/);
    return match ? match[1] : null;
  };

  const loopableSrc = (() => {
    const baseUrl = videoframe();
    const videoId = getVideoId(baseUrl);
    const connector = baseUrl.includes('?') ? '&' : '?';
    // autoplay, loop and playlist=videoId
    return videoId
      ? `${baseUrl}${connector}autoplay=1&loop=1&playlist=${videoId}`
      : baseUrl;
  })();

  const images = () => {
    const imgArray = dta.flatMap(i =>
      i.RecentClip.map(a => a.RecentClipImage)
    );
    return imgArray.join(', ');
  };

  const darkcolor = props.data.length > 0
    ? props.data[0].darkColor
    : null;

  return (
    <div>
      <div className="locationdetail-page-head">
        <h5 style={{ color: darkcolor }}>what we do</h5>
        <h4>Our Recent Clip</h4>
      </div>

      <div
        className="video-section"
        style={{
          backgroundImage: `url(${
            images()
              ? `https://backend.corporateeventplanner.in/storage/location-gallery/${images()}`
              : 'image/thumbnail2.jpg'
          })`,
        }}
      >
        <div className="background-image">
          {/* you can hide this button if you don't want a close button only */}
          <button className="play-button" onClick={() => setIsOpen(true)}>
            ▶
          </button>
        </div>

        {isOpen && (
          <div className="video-popup">
            <div className="video-container">
              <span className="close-button" onClick={closeVideo}>
                &times;
              </span>
           <iframe
              width="100%"
              height="600px"
              src={`${loopableSrc}&autoplay=1&mute=1`} // autoplay + mute for autoplay compliance
              title="YouTube video player"
              frameBorder="0"
              allow="autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>

            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Locationvideo;
